import { z } from 'zod'

import { useNav, useParseQuery } from '../../../hooks/useNav'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { PATH } from '../../../data/router_path'
import HeaderLayout from '../../../layouts/Header'
import SearchHeader from '../../../components/function/filters/SearchHeader'
import Select from '../../../components/function/filters/Select'
import Date from '../../../components/function/filters/Date'
import { convertFilterDateFormat } from '../../../utils/conversion'
import { showErrorToast } from '../../../utils/showToast'
import { useLocation } from 'react-router-dom'
const accountFilterSchema = z.object({
  keyword: z.string().nullable().optional(),
  all_radio: z.boolean().nullable().optional(),
  date_fixed_radio: z.boolean().nullable().optional(),
  date_fixed: z.string().nullable().optional(),
  date_range_radio: z.boolean().nullable().optional(),
  date_from: z.string().nullable().optional(),
  date_to: z.string().nullable().optional(),
})
export default function AccountGuestFilterHeader() {
  const location = useLocation()
  const arrLocation= location.pathname.split('/')
  const isPageAccountGuest =  arrLocation[1]
  const navigate = useNav()
  const { queryParams } = useParseQuery()

  const { control, handleSubmit, setValue } = useForm({
    resolver: zodResolver(accountFilterSchema),
    defaultValues: {
      keyword: '',
      all_radio: true,
      date_fixed_radio: false,
      date_fixed: undefined,
      date_range_radio: false,
      date_from: undefined,
      date_to: undefined,
    },
  })
  const searchHandler = (formValue) => {
    const {
      all_radio,
      date_fixed_radio,
      date_range_radio,
      keyword,
      date_fixed,
      date_from,
      date_to,
    } = formValue
    let filters = { ...queryParams, keyword }
    if (all_radio) {
      filters.joinDate = undefined
    }
    if (date_fixed_radio) {
      if (!date_fixed) {
        showErrorToast({
          message: 'Vui lòng chọn ngày cụ thể',
        })
        return
      }
      filters.joinDate = `${convertFilterDateFormat(date_fixed)}-${convertFilterDateFormat(date_fixed)}`
    } else if (date_range_radio) {
      if (!date_from || !date_to) {
        showErrorToast({
          message: 'Vui lòng chọn đủ khoảng ngày',
        })
        return
      }
      filters.joinDate = `${convertFilterDateFormat(date_from)}-${convertFilterDateFormat(date_to)}`
    }

    navigate(PATH.ACCOUNT.GUEST.LIST, { params: filters })
  }
  const handleRadioChange = (selectedName, newValue) => {
    if (newValue) {
      setValue('all_radio', selectedName === 'all_radio')
      setValue('date_fixed_radio', selectedName === 'date_fixed_radio')
      setValue('date_range_radio', selectedName === 'date_range_radio')
    } else {
      setValue('all_radio', true)
    }
  }
  return (
    <HeaderLayout>
      <form
        onSubmit={handleSubmit(searchHandler)}
        className={'flex flex-col justify-center gap-4'}
      >
        <SearchHeader
          title={'Tài khoản khách'}
          placeholder="Tìm kiếm tên tài khoản, mã sinh viên, email..."
          control={control}
          name={'keyword'}
        />
        {isPageAccountGuest ==='info-guest-account' ? null:
        <div className="flex items-center justify-between gap-4 text-base font-semibold">
          {/* <Button
            variant="primary"
            onClick={() => navigate(PATH_CREATE_ACCOUNT)}
            className="gap-2 whitespace-nowrap"
            type="button"
          >
            <Icon
              icon="ph:plus"
              width="24px"
              height="24px"
              style={{ color: 'white' }}
            />
            Tạo tài khoản
          </Button> */}
          <Select
            control={control}
            name={'all_radio'}
            title={'Tất cả'}
            onChangeHandler={handleRadioChange}
          />
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_fixed_radio'}
              onChangeHandler={handleRadioChange}
            />
            <Date control={control} name={'date_fixed'} title={'Ngày'} />
          </div>
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_range_radio'}
              onChangeHandler={handleRadioChange}
            />

            <div className="flex items-center gap-3">
              <Date control={control} name={'date_from'} title={'Từ'} />
              <Date control={control} name={'date_to'} title={'Đến'} />
            </div>
          </div>
        </div>}
      </form>
    </HeaderLayout>
  )
}
